module.exports = __webpack_public_path__ + "static/icon-matriculacion.251ee594.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-matriculacion.svg
// module id = 562
// module chunks = 243485111170538